import React from 'react';
import { ArticleCard } from '../components/ArticleCard';
import { articles } from '../data/articles';
export function Articles() {
  const [lead, ...rest] = articles;
  return <div data-id="element-208" data-mp="31dumy0f00w8s">
      <section className="border-b border-line bg-canvas" data-id="element-209" data-mp="31d347q6i2szx">
        <div className="mx-auto max-w-7xl px-5 py-12 lg:px-8 lg:py-16" data-id="element-210" data-mp="31fpbdophb6hm">
          <h1 className="font-display text-5xl font-bold uppercase text-navy" data-id="element-211" data-mp="36dh3oju1cumc">Featured Articles</h1>
          <p className="mt-3 max-w-2xl text-lg text-muted" data-id="element-212" data-mp="3baz8pz4xmpp2">
            Design trends, builder spotlights, and life in Cape Coral from the Builders’ Showcase of Homes.
          </p>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-5 py-14 lg:px-8" data-id="element-213" data-mp="3l2dhyymor3ve">
        {lead && <ArticleCard article={lead} layout="row" data-id="element-214" data-mp="3p244gq56ixu4" />}
        <div className="mt-14 grid gap-x-8 gap-y-14 border-t border-line pt-14 md:grid-cols-2" data-id="element-215" data-mp="3u2a0eiihf6i0">
          {rest.map(a => <ArticleCard key={a.id} article={a} data-id="element-216" data-mp="2vfjdb7dtrfa" />)}
        </div>
      </section>
    </div>;
}